<!--  -->
<template>
  <div>
    <div>
      <el-row>
        <el-col :span="24" v-if="statusView!='C'">
            <el-button size="mini" @click="addData" type="primary">新增</el-button>
            <el-button size="mini" :disabled="multipleSelection.length>0?false:true" @click="delData" type="danger">删除</el-button>
            <el-button size="mini" @click="saveData" type="primary">保存</el-button>
        </el-col>
      </el-row>
      <ux-grid
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;margin-top:15px;"
        @selection-change="handleSelectionChange"
      >
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column title="Min类型">
          <template slot-scope="scope">
            <el-select v-model="scope.row.minType" placeholder="请选择" clearable style="width:100%">
              <el-option
                v-for="item in minOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </ux-table-column>
        <ux-table-column prop="name" title="Min" >
          <template slot-scope="scope">
            <el-input v-model="scope.row.min" clearable style="width:100%"></el-input>
          </template>
        </ux-table-column>
        <ux-table-column prop="name" title="Max类型" >
           <template slot-scope="scope">
             <el-select v-model="scope.row.maxType" placeholder="请选择" clearable style="width:100%">
              <el-option
                v-for="item in maxOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
           </template>
        </ux-table-column>
        <ux-table-column prop="name" title="Max" >
          <template slot-scope="scope">
             <el-input v-model="scope.row.max" clearable style="width:100%"></el-input>
          </template>
        </ux-table-column>
        <ux-table-column prop="name" title="等级" >
            <template slot-scope="scope">
                <el-input v-model="scope.row.grade" clearable style="width:100%"></el-input>
            </template>
        </ux-table-column>
        <ux-table-column prop="name" title="排序" >
            <template slot-scope="scope">
                <el-input v-model="scope.row.orderNo" @input="scope.row.orderNo= scope.row.orderNo.replace(/[^\d.]/g,'')" clearable style="width:100%"></el-input>
            </template>
        </ux-table-column>
      </ux-grid>
    </div>
  </div>
</template>

<script>
import apiService  from "@/api/AAA/index.js";

export default {
  props:['detailInfo','templateId','temStatus'],
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      rulesList:localStorage.getItem('ms_roles'),
      identity:localStorage.getItem('ms_emplFlag'),
      maxOption:[{
        label:"<",
        value:"<"
      },{
        label:"<=",
        value:"<="
      }],
      minOption:[{
        label:">",
        value:">"
      },{
        label:">=",
        value:">="
      }],
    };
  },

  components: {},

  computed: {},
  created(){
    this.tableData=this.detailInfo
    if (this.identity=='SUP') {   //判断是供应商
      this.statusView = 'S';
    }else {
      if(this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1||this.rulesList.indexOf('QSPI_AAA_ADMIN')!=-1){
        this.statusView='All'
      }else{
        this.statusView='C'
      }
    }
  },
  methods: {
    addData(){
      this.tableData.push({
        minType:"",
        min:"",
        maxType:"",
        max:"",
        grade:"",
        orderNo:""
      })
    },
    delData(){
      let params=[]
      this.multipleSelection.forEach((v)=>{
        params.push(v.ttQspiScoreRuleDetailId)
      })
      apiService.deleteBatch(params,this.templateId).then((res)=>{
        if(res.code==200){
          this.$message.success('删除成功')
          this.$emit('closeRubricg')
        }else{
          this.$message.error(res.msg)
        }
      })
      // this.tableData = this.tableData.filter(item => !this.multipleSelection.some(ele=>ele.ttQspiScoreRuleDetailId===item.ttQspiScoreRuleDetailId));
    },
    saveData(){
      apiService.editBatch(this.tableData,this.temStatus,this.templateId).then((res)=>{
        if(res.code==200){
          this.$message.success('保存成功')
          this.$emit('closeRubricg')
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  watch:{
    detailInfo(val){
      this.tableData=val
    }
  }
};
</script>
<style  scoped>
</style>